import { useMemo } from "react";

export const BUTTON_TYPES = {
  COMBINED_DROPDOWN: 'combined_dropdown',
  CREATE_BUTTON: 'create_button',
  RESEND_DROPDOWN: 'resend_dropdown',
  DISABLED: 'disabled'
};

export const useShipmentsButtonType = (order) => {
  return useMemo(() => {
    const { allowProcessShipments, allowResendShipments } = order.uiState;
    const hasResendableShipments = order.resendableShipments && order.resendableShipments.length > 0;

    if (allowProcessShipments && allowResendShipments) {
      return BUTTON_TYPES.COMBINED_DROPDOWN;
    }

    if (allowProcessShipments && !allowResendShipments) {
      return BUTTON_TYPES.CREATE_BUTTON;
    }

    if (!allowProcessShipments && allowResendShipments && hasResendableShipments) {
      return BUTTON_TYPES.RESEND_DROPDOWN;
    }

    return BUTTON_TYPES.DISABLED;
  }, [order.uiState.allowProcessShipments, order.uiState.allowResendShipments, order.resendableShipments]);
}; 